/* global axios */
import ApiClient from '../ApiClient';

class NexceoProjectTeamMembersAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  list(projectId) {
    return axios.get(`${this.url}/${projectId}/team_members`);
  }

  get(projectId, memberId) {
    return axios.get(`${this.url}/${projectId}/team_members/${memberId}`);
  }

  create(projectId, data) {
    return axios.post(`${this.url}/${projectId}/team_members`, {
      team_member: data,
    });
  }

  update(projectId, memberId, data) {
    return axios.put(`${this.url}/${projectId}/team_members/${memberId}`, {
      team_member: data,
    });
  }

  destroy(projectId, memberId) {
    return axios.delete(`${this.url}/${projectId}/team_members/${memberId}`);
  }
}

export default new NexceoProjectTeamMembersAPI();
